import { normalizeBrandName } from '@/utils/mappers/normalize-brand-name';
import type { AlgoliaProduct } from '@/lib/algolia/types';
import type { Product } from '@/types/entity/product';
import type { GA4Item } from './dataLayer';

const ELECTUS_TAXONOMY = new Set([
  'Auto & Outdoors',
  'Power & Ecotech',
  'Sight & Sound',
  'Gifts & Gadgets',
  'Security & Surveillance',
  'IT & Communications',
  'Tools & Test Equipment',
  'Electronic Components',
]);

export const extractElectusCategory = (categories: Array<{ name?: string }>): string | undefined => {
  const names = categories.map((c) => c.name).filter((n): n is string => !!n);
  return names.find((n) => ELECTUS_TAXONOMY.has(n)) ?? names[0];
};

const resolveGA4Price = (hit: AlgoliaProduct): number => {
  const priceGroup = Array.isArray(hit.priceGroup) ? hit.priceGroup : [];
  const active = priceGroup[0]?.activePrice;
  if (typeof active?.centAmount === 'number') {
    return active.centAmount / 100;
  }
  const topRrp = (hit as unknown as { rrp?: unknown }).rrp;
  return typeof topRrp === 'number' ? topRrp : 0;
};

export const algoliaHitToGA4Item = (hit: AlgoliaProduct, index: number, listId: string, listName: string): GA4Item => ({
  item_id: hit.sku ?? hit.objectID,
  item_name: hit.name ?? '',
  item_brand: normalizeBrandName(hit.brand),
  item_category: extractElectusCategory(hit.categories ?? []),
  price: resolveGA4Price(hit),
  index,
  item_list_id: listId,
  item_list_name: listName,
});

export const mappedProductToGA4Item = (
  product: Product,
  index: number,
  listId: string,
  listName: string,
  opts?: { in_stock?: boolean },
): GA4Item => ({
  item_id: product.sku ?? '',
  item_name: product.name ?? '',
  item_brand: product.brand,
  item_category: extractElectusCategory(product.categories ?? []),
  price: product.price ?? 0,
  index,
  item_list_id: listId,
  item_list_name: listName,
  ...(opts?.in_stock !== undefined ? { in_stock: opts.in_stock } : {}),
});
